export default "__VITE_ASSET__CXkSSTuc__"